export const lt = {
    LEFT: 'Kairėje: pereina prie ankstesnio dienos.',
    RIGHT: 'Dešinėn-Perkelti į kitą dieną. | | "Žemyn": Perkelti į kitą eilutę.',
    DOWN: 'Iki: pereina prie ankstesnio eilės.',
    UP: 'PgUp: Perkelti ankstesnį mėnesį.',
    PGUP: 'PgDown: Perkelti į kitą mėnesį.',
    PGDOWN: 'Namo: Perkelti į ankstesnių metų.',
    HOME: 'Pabaiga: Perkelti į kitus metus.',
    END: 'Esc/Šiandien/Arti: uždaryti į kalendorių.',
    ESC: 'Klaviatūra Instrukcijos'
};
